import { useEffect } from 'react';

import { useModalStore } from './ModalStore';

function useModalScrollLock(): void {
  const { hasOpenedModals } = useModalStore();

  useEffect(() => {
    document.body.style.position = hasOpenedModals ? 'fixed' : 'initial';
  }, [hasOpenedModals]);
}

export default useModalScrollLock;
